import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Auth from '../components/Auth';
import { setUserLoggedIn } from '../features/auth/auth.slice';

const AuthPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setUserLoggedIn());
  }, [dispatch]);

  const { loggedIn } = useSelector((state) => state.auth);
  if (loggedIn) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <Auth />
    </>
  );
};

export default AuthPage;
